import React, {useEffect} from 'react';
import {useFormik} from 'formik'
import {Button, Input, Skeleton} from "antd";
import {ErrorMessageWidget} from "@/components/form/errorMessageWidget";
import {useApiDeleteAdminPollSurvey, useApiReadAdminPollSurvey, useApiUpdateAdminPollSurvey} from "@/api/survey";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {URLS} from "@/lib/urls";

import {useNavigate, useParams} from "react-router-dom";
import useWindowDimensions from "@/hook/useWindowDimensions";
import FreeBox from "@/components/box/freeBox";
import PermList from "@/lib/helper/PermList";
import {Can} from "@/components/can/Can";
import TextArea from "antd/lib/input/TextArea";

function EditSurveySection() {

    const param = useParams()
    const id = param.id;
    const {width} = useWindowDimensions();


    const navigate = useNavigate();


    const {data, isPending: isPendingGet} = useApiReadAdminPollSurvey(id)
    const {mutate: editSurvey, isPending: isPendingEdit} = useApiUpdateAdminPollSurvey()
    const {mutate: deleteSurvey, isPending: isPendingDelete} = useApiDeleteAdminPollSurvey()

    const formik = useFormik({
        initialValues: {}, validate: (values) => {
            return {};
        }, onSubmit: (values) => {


            editSurvey({id: id, data: values},
                {
                    onSuccess: (res) => {
                        ApiHandleSuccessMessage(res)
                    },
                    onError: (res) => {
                        ApiHandleErrorMessage(res)
                    },
                })


        }
    })


    const isPending = isPendingEdit || isPendingGet;

    useEffect(() => {
        formik.setFieldValue('title', data?.data?.data?.title)
        formik.setFieldValue('description', data?.data?.data?.description)


    }, [data]);


    const confirmRemove = (e) => {
        deleteSurvey({id: id},
            {
                onSuccess: (res) => {
                    ApiHandleSuccessMessage(res)
                    navigate(URLS.admin.survey.dashboard)
                },
                onError: (res) => {
                    ApiHandleErrorMessage(res)
                },
            })

    };

    if (isPendingGet) {
        return <Skeleton active/>
    }

    return (<>
            <FreeBox>


                <div className={'m-2'}>
                    <div className={`flex flex-col gap-1`}>
                        <span className={`font-medium`}>عنوان نظرسنجی </span>
                        <Input placeholder={"عنوان را وارد کنید"}
                               value={formik.values.title}
                               disabled={isPending}
                               status={formik.errors.title && "error"}
                               onChange={(e) => formik.setFieldValue("title", e.target.value)}
                        />
                        {formik.errors.title && <ErrorMessageWidget message={formik.errors.title}/>}
                    </div>

                    <div className={`flex flex-col gap-1`}>
                        <span className={`font-medium`}>توضیحات </span>
                        <Input.TextArea placeholder={"توضیحات"}
                                  value={formik.values.description}
                                  disabled={isPending}
                                  status={formik.errors.description && "error"}
                                  onChange={(e) => formik.setFieldValue("description", e.target.value)}
                        />
                        {formik.errors.description && <ErrorMessageWidget message={formik.errors.description}/>}
                    </div>
                </div>

                <div className={`mt-4 flex justify-end`}>

                    <Can permission={PermList.SURVEY_EDIT}>
                        <Button onClick={formik.submitForm} type={'primary'} loading={isPendingEdit}
                                disabled={isPendingGet || isPendingDelete}>
                            {'ویرایش'}
                        </Button>
                    </Can>

                </div>
            </FreeBox>


        </>


    )
}

export default EditSurveySection;


